import {
  HiOutlineHome,
  HiOutlineMap,
  HiOutlineDocumentText,
  HiOutlineClipboardList,
  HiOutlineOfficeBuilding,
  HiOutlineChartBar
} from "react-icons/hi";

export const services = [
  {
    category: "Saneamiento Legal",
    items: [
      {
        slug: "declaratoria-fabrica",
        title: "Declaratoria de Fábrica",
        description: "Regularización de edificaciones ante registros públicos.",
        icon: <HiOutlineDocumentText />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Incrementa el valor comercial del inmueble", "Facilita el acceso a créditos hipotecarios", "Seguridad jurídica sobre la construcción realizada"],
        process: ["Levantamiento de planos", "Elaboración de informe técnico", "Ingreso de expediente a SUNARP"]
      },
      {
        slug: "prescripcion-adquisitiva",
        title: "Prescripción Adquisitiva",
        description: "Obtén la propiedad legal de un inmueble.",
        icon: <HiOutlineClipboardList />,
        duration: "7 a 15 días",
        price: "Desde S/ 2,000",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Titulación definitiva del predio", "Posibilidad de heredar legalmente", "Fin de conflictos de posesión"],
        process: ["Evaluación de antigüedad de posesión", "Recopilación de pruebas", "Trámite notarial o judicial"]
      },
      {
        slug: "independizacion-viviendas",
        title: "Independización de Viviendas",
        description: "Divide legalmente tu propiedad.",
        icon: <HiOutlineHome />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Venta individual de unidades", "Independencia de servicios básicos", "Facilidad para hipotecar partes del predio"],
        process: ["Elaboración de planos de subdivisión", "Memoria descriptiva", "Inscripción en Registros Públicos"]
      },
      {
        slug: "independizacion-pisos",
        title: "Independización por Pisos",
        description: "Formaliza unidades por niveles.",
        icon: <HiOutlineOfficeBuilding />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Partida registral por cada nivel", "Orden legal entre copropietarios", "Optimización de impuestos"],
        process: ["Reglamento interno", "Planos de áreas comunes", "Inscripción SUNARP"]
      },
      {
        slug: "acumulacion-predios",
        title: "Acumulación de Predios",
        description: "Unifica terrenos en una sola partida.",
        icon: <HiOutlineHome />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Simplificación de trámites", "Mejor gestión de proyectos grandes", "Unificación de la unidad catastral"],
        process: ["Verificación de colindancia", "Planos de acumulación", "Trámite administrativo"]
      }
    ]
  },
  {
    category: "Subdivisión y Desarrollo",
    items: [
      {
        slug: "subdivision-lotes",
        title: "Subdivisión de Lotes Urbanos",
        description: "Divide terrenos cumpliendo normativa.",
        icon: <HiOutlineMap />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Aprovechamiento máximo del suelo", "Cumplimiento con parámetros municipales", "Aumento de rentabilidad"],
        process: ["Certificado de parámetros", "Proyecto de subdivisión", "Aprobación municipal"]
      },
      {
        slug: "lotizaciones",
        title: "Lotizaciones",
        description: "Diseño y planificación de lotes.",
        icon: <HiOutlineChartBar />,
        duration: "7 a 15 días",
        price: "Desde S/ 2,000",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Diseño urbano eficiente", "Viabilidad de servicios básicos", "Proyectos listos para comercializar"],
        process: ["Estudio de suelos", "Diseño de vías y lotes", "Gestión de habilitación urbana"]
      }
    ]
  },
  {
    category: "Estudios Técnicos",
    items: [
      {
        slug: "busqueda-catastral",
        title: "Búsqueda Catastral",
        description: "Verificación técnica del predio.",
        icon: <HiOutlineMap />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Evita superposiciones de áreas", "Confirmación de linderos reales", "Previene estafas inmobiliarias"],
        process: ["Solicitud ante SUNARP", "Análisis de base gráfica", "Entrega de certificado"]
      },
      {
        slug: "levantamiento-topografico",
        title: "Levantamiento Topográfico",
        description: "Medición precisa del terreno.",
        icon: <HiOutlineChartBar />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Medidas exactas con equipos GPS/Estación Total", "Base para cualquier diseño de ingeniería", "Identificación de desniveles"],
        process: ["Trabajo de campo", "Procesamiento de datos en gabinete", "Entrega de planos en CAD"]
      },
      {
        slug: "informe-tecnico",
        title: "Informe Técnico",
        description: "Documento técnico profesional.",
        icon: <HiOutlineDocumentText />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Diagnóstico real del estado del predio", "Sustento para trámites legales", "Claridad en la toma de decisiones"],
        process: ["Inspección ocular", "Cálculos e ingeniería", "Redacción y firma colegiada"]
      }
    ]
  },
  {
    category: "Diseño de Construcción",
    items: [
      {
        slug: "planos-edificacion",
        title: "Planos de Edificación",
        description: "Diseño arquitectónico profesional.",
        icon: <HiOutlineClipboardList />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,000",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Espacios funcionales y estéticos", "Seguridad estructural ante sismos", "Aprobación de licencia de construcción"],
        process: ["Entrevista de necesidades", "Anteproyecto arquitectónico", "Planos de especialidades (Estructuras, IIEE, IISS)"]
      },
      {
        slug: "ampliaciones-remodelaciones",
        title: "Ampliaciones y Remodelaciones",
        description: "Optimiza y moderniza tu vivienda.",
        icon: <HiOutlineHome />,
        duration: "7 a 15 días",
        price: "Desde S/ 1,500",
        requirements: [
          "Copia de DNI del propietario",
          "Título de propiedad",
          "Plano del inmueble",
          "Recibo de servicios"
        ],
        scope: [
          "Aplica en todo el Perú",
          "Inscripción en SUNARP",
          "Cumplimiento de normativa municipal"
        ],
        benefits: ["Modernización de ambientes", "Mejora de la calidad de vida", "Optimización de la iluminación y ventilación"],
        process: ["Evaluación de estructuras existentes", "Propuesta de diseño", "Ejecución de obra"]
      }
    ]
  }
];